export default "__VITE_ASSET__CTLMAPY8__"